var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex flex-column h-100"},[(_vm.props.loading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('span',{staticClass:"spinner-border"})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }